var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobCartIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4093",
    "data-name": "Group 4093",
    transform: "translate(-51 -67)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1026",
    "data-name": "Ellipse 1026",
    cx: 25.5,
    cy: 25.5,
    r: 25.5,
    transform: "translate(51 67)",
    fill: "#ff3600"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-cart",
    "data-name": "Icon ionic-ios-cart",
    transform: "translate(63.62 79.234)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5105",
    "data-name": "Path 5105",
    d: "M11.755,29.221a1.1,1.1,0,1,1-1.1-1.1,1.1,1.1,0,0,1,1.1,1.1Z",
    transform: "translate(-2.165 -8.278)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5106",
    "data-name": "Path 5106",
    d: "M27.54,29.221a1.1,1.1,0,1,1-1.1-1.1,1.1,1.1,0,0,1,1.1,1.1Z",
    transform: "translate(-7.695 -8.278)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5107",
    "data-name": "Path 5107",
    d: "M22.372,7.613a.269.269,0,0,0-.238-.192L7.256,5.982a.458.458,0,0,1-.343-.215,4.652,4.652,0,0,0-.557-.85C6,4.488,5.342,4.5,4.127,4.493a.666.666,0,0,0-.745.644.653.653,0,0,0,.713.644,6.07,6.07,0,0,1,1.188.087c.215.064.388.416.452.722a.017.017,0,0,0,0,.014c.009.055.091.466.091.471L7.658,16.74a3.552,3.552,0,0,0,.662,1.631,1.823,1.823,0,0,0,1.5.74H20.631a.649.649,0,0,0,.658-.612.636.636,0,0,0-.64-.667H9.814a.531.531,0,0,1-.379-.128,2.05,2.05,0,0,1-.525-1.188l-.2-1.083a.025.025,0,0,1,.018-.027l12.686-2.147a.267.267,0,0,0,.224-.238l.731-5.29A.261.261,0,0,0,22.372,7.613Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobCartIcon);
export default __webpack_public_path__ + "static/media/mob_cart_icon.45f019cc8816ef1184c32e7c2144d1f4.svg";
export { ForwardRef as ReactComponent };